var map = {
	"./_MG_4195.jpg": 31861,
	"./_MG_4213.jpg": 50678,
	"./_MG_9631.jpg": 87460,
	"./_MG_9669.jpg": 77835,
	"./_MG_9678.jpg": 18136,
	"./_MG_9681.jpg": 37540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85405;